import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { downloadAgendaBriefAction } from "../../actions/mom.action";
import { get } from "lodash";
import { toast } from "react-toastify";
import { ERROR_MSG } from "../../constant";
import { LoaderPage } from "../Loader";
import { successToastStyle, errorToastStyle } from "../../customToast";

export class DownloadAgendaBrief extends Component {
  state = {
    showLoader: false
  };

  downloadAgendaBrief = async id => {
    this.setState({ showLoader: true });
    const resp = await downloadAgendaBriefAction(undefined, id);
    if (resp) {
      const { status, data } = resp;
      if (status && data) {
        this.setState({ showLoader: false });
        window.location.href = get(data, "data");
        toast.success(
          <p className="toast-text-alignment">{ERROR_MSG.DOWNLOAD_SUCCESS}</p>,
          successToastStyle
        );
      } else {
        this.setState({ showLoader: true });
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.INVALID_LINK}</p>,
          errorToastStyle
        );
      }
    } else {
      this.setState({ showLoader: true });
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_LINK}</p>,
        errorToastStyle
      );
    }
  };

  render() {
    const { id } = this.props;
    const { showLoader } = this.state;
    return (
      <React.Fragment>
        <LoaderPage loading={showLoader} />
        <Button
          className="btn-orange-invert no-padding download-draft"
          onClick={() => this.downloadAgendaBrief(id)}
        >
          <div className="download-icon orange" /> Brief Agenda
        </Button>
      </React.Fragment>
    );
  }
}

export default DownloadAgendaBrief;
